// The DS pipeline returns markers like "<content is unreadable>" when the LLM can't produce a value.
export const isLlmErrorMarker = (value: string): boolean => /^<.+>$/.test(value);
